import { useMemo, useState, Fragment } from 'react';
import { useTheme, Tab, Tabs, Tooltip } from '@mui/material';
import { PageLayout } from '../../../../PageLayout';
import { DEFAULT_TAB_SX_STYLES } from '../../../../../utils/styleHelpers';
import { TabPanel } from '../../../../Atoms/TabPanel';
import { CustomerMapTab } from './CustomerMapTab';
import { UnmappedCustomerTab } from './UnmappedCustomerTab';
import { CustomerMergeList } from './CustomerMergeList';

export const CustomerMap = () => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = useMemo(
    () => [
      {
        name: 'Customer Map',
        tooltip: 'View customer maps.',
        component: CustomerMapTab
      },
      {
        name: 'Unmapped RPM Customers',
        tooltip: 'View unmapped RPM customers.',
        component: UnmappedCustomerTab
      },
      {
        name: 'RPM Customer Merge List',
        tooltip: 'View RPM customer merge list.',
        component: CustomerMergeList
      }
    ],
    []
  );

  return (
    <PageLayout
      className="w-full mt-0"
      dataTestId="customer-map-page"
      dataCy="customer-map-page-card"
      pageTitle="">
      <Fragment>
        <Tabs
          sx={DEFAULT_TAB_SX_STYLES}
          value={selectedTab}
          scrollButtons="auto"
          onChange={(_e, index) => {
            setSelectedTab(index);
          }}
          slotProps={{
            indicator: {
              sx: {
                backgroundColor: theme.palette.primary.main,
                height: 2,
                borderRadius: 1
              }
            }
          }}>
          {tabs.map((tab, _index) => (
            <Tab
              sx={{
                color: 'grey9',
                fontSize: '.8rem',
                textTransform: 'none'
              }}
              key={tab.name}
              label={
                <Tooltip
                  title={<span style={{ whiteSpace: 'pre-line' }}>{tab.tooltip}</span>}
                  slotProps={{
                    tooltip: {
                      sx: {
                        maxWidth: 'none',
                        width: 'auto'
                      }
                    }
                  }}>
                  <span>{tab.name}</span>
                </Tooltip>
              }
            />
          ))}
        </Tabs>
      </Fragment>
      {tabs.map((tab, index) => (
        <TabPanel
          key={tab.name}
          value={selectedTab}
          index={index}>
          <tab.component />
        </TabPanel>
      ))}
    </PageLayout>
  );
};
